"use client";

const formatTimeUnit = (value: number, unit: string): string =>
  `${value} ${unit}${value === 1 ? "" : "s"}`;

export const getFormattedTimeLeft = (secondsLeft: number): string => {
  const hours = Math.floor(secondsLeft / 3600);
  secondsLeft %= 3600;
  const minutes = Math.floor(secondsLeft / 60);
  const seconds = secondsLeft % 60;

  const timeParts = [];
  if (hours > 0) {
    timeParts.push(formatTimeUnit(hours, "hour"));
  }
  if (minutes > 0) {
    timeParts.push(formatTimeUnit(minutes, "minute"));
  }
  if (seconds > 0 || timeParts.length === 0) {
    timeParts.push(formatTimeUnit(seconds, "second"));
  }

  // Once hours are shown, seconds are noise; the seconds part is always last when present.
  if (hours > 0 && seconds > 0) {
    timeParts.pop();
  }

  return timeParts.join(" ");
};
